import { useState } from "react";
import useSWR from "swr";
import { Trash2, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, fetcher, asList, imgUrl } from "@/lib/api";

const Quote = ({ q, onDelete }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-[#D4AF37]/20 bg-[#13141C]" data-testid={`admin-quote-${q.id}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-4 p-4 text-left">
        <div className="flex-1 min-w-0">
          <p className="text-[#F5F3EF]">
            {q.kind === "samples" && <span className="mr-2 font-mono-j text-[10px] uppercase tracking-[0.2em] text-[#0D0D11] bg-[#D4AF37] px-2 py-0.5" data-testid={`admin-quote-kind-${q.id}`}>Samples</span>}
            {q.name} <span className="text-[#A09E97] text-sm">· {q.email}</span>
          </p>
          <p className="text-xs text-[#A09E97]">{new Date(q.created_at).toLocaleString()} · {asList(q.items).length} {q.kind === "samples" ? "samples" : "products"}{asList(q.pairings).length ? ` · ${q.pairings.length} pairings` : ""}{q.emailed ? "" : " · email not sent"}</p>
        </div>
        <span className="font-mono-j text-[11px] text-[#E5C158]">{open ? "HIDE" : "VIEW"}</span>
      </button>
      {open && (
        <div className="px-4 pb-4 text-sm space-y-3">
          {q.phone && <p className="text-[#A09E97]">{q.kind === "samples" ? "Mobile" : "Phone"}: <span className="text-[#F5F3EF]">{q.phone}</span></p>}
          {q.address && <p className="text-[#A09E97]" data-testid={`admin-quote-address-${q.id}`}>Deliver to: <span className="text-[#F5F3EF] whitespace-pre-line">{q.address}</span></p>}
          {q.kind === "samples" && <p className="text-[#E5C158] text-xs font-mono-j uppercase tracking-[0.15em]">To do: book quote &amp; design session · send samples</p>}
          {q.message && <p className="text-[#F5F3EF] whitespace-pre-line">{q.message}</p>}
          {asList(q.pairings).length > 0 && (
            <div className="border-t border-[#D4AF37]/15 pt-3 space-y-1" data-testid={`admin-quote-pairings-${q.id}`}>
              <p className="font-mono-j text-[11px] uppercase tracking-[0.2em] text-[#C5A059]">Pairings</p>
              {q.pairings.map((p, n) => (
                <div key={n}>
                  <p className="text-[#F5F3EF]">{n + 1}. {p.board?.name || "—"} + {p.stone?.name || "—"}{p.handle ? ` + ${p.handle.name}` : ""}{p.finish ? <span className="text-[#A09E97]"> ({p.finish})</span> : null}</p>
                  {p.snapshot && <a href={imgUrl(p.snapshot)} target="_blank" rel="noreferrer" data-testid={`admin-quote-snapshot-${q.id}-${n}`}><img src={imgUrl(p.snapshot)} alt="" className="mt-1 h-24 w-auto border border-[#D4AF37]/25" /></a>}
                </div>
              ))}
            </div>
          )}
          <ul className="border-t border-[#D4AF37]/15 pt-3 space-y-1">
            {asList(q.items).map((i) => <li key={i.id} className="text-[#F5F3EF]">{i.name} <span className="text-[#A09E97]">{[i.code, i.supplier, i.category_name].filter(Boolean).join(" · ")}</span></li>)}
          </ul>
          <div className="flex gap-4 pt-2">
            <a href={`mailto:${q.email}`} className="inline-flex items-center gap-2 text-[#E5C158]"><Mail className="w-4 h-4" /> Reply</a>
            <button onClick={() => onDelete(q)} data-testid={`delete-quote-${q.id}`} className="inline-flex items-center gap-2 text-[#A09E97] hover:text-red-400"><Trash2 className="w-4 h-4" /> Delete</button>
          </div>
        </div>
      )}
    </div>
  );
};

export const QuoteList = () => {
  const { data, mutate } = useSWR("/quotes", fetcher);
  const quotes = asList(data);
  const remove = async (q) => {
    if (!window.confirm(`Delete request from ${q.name}?`)) return;
    await api.delete(`/quotes/${q.id}`);
    toast.success("Request deleted");
    mutate();
  };
  return (
    <div className="space-y-3" data-testid="admin-quotes-list">
      {quotes.map((q) => <Quote key={q.id} q={q} onDelete={remove} />)}
      {quotes.length === 0 && <p className="p-10 text-center text-[#A09E97] border border-[#D4AF37]/15">No quote requests yet.</p>}
    </div>
  );
};
